module.exports = __webpack_public_path__ + "img/me-night-top-bg_zh.26e338b5.png";